export const REQUEST_ERROR = /\w+_ERROR$/g;
export const PHONE = /^\+?\d{1}\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}$/;
export const PHONE_TEXT_MASK = ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
export const COORD = /\d{2}[.,]\d{1,}/;
